<template>
	<div class="pastorderwin">
		<el-dialog :visible.sync="showpastorderwin" title="输入单号" width="500px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<div style="height:430px" align="center">
				<table class="htmltable">
					<tr>
						<td><span>检测字段</span></td>
						<td>
							<el-select size="mini" v-model="checkcol" placeholder="请选择" style="width:200px" @change="changecheckcol">
								<el-option v-for="item in checkcoloption" :key="item.checkcol" :label="item.checkcol" :value="item.checkcol"></el-option>
							</el-select>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							<el-input
								:rows="13"
								type="textarea"
								style="overflow-y:auto;margin-top:10px"
								v-model="orderids"
								@keyup.native="event => CheckPasteOrder(event)"
							></el-input>
						</td>
					</tr>
					<tr>
						<td colspan="2" style="text-align:left;">
							<div>
								<!--  -->
								<span>共输入 {{ allcount }} 个单号</span>
								<span v-if="yxcount > -1" style="margin-left:20px">有效单号 {{ yxcount }} 个</span>
							</div>
							<!--  -->
							<div v-if="filename!=''"><a :href="filename">下载无效单号</a></div>
						</td>
					</tr>
					<tr style="height:80px;">
						<td colspan="2" style="width:310px;text-align:center">
							<el-button type="success" size="mini" @click="nextstep" :disabled="btndisabled">下一步</el-button><el-button size="mini" @click="showpastorderwin = false">取消</el-button>
						</td>
					</tr>
				</table>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			orderids: '',
			allcount: 0,
			yxcount: -1,
			checkedbatch: '',
			filename: '', //无效的单号文件
			showpastorderwin: false, //是否显示粘贴单号窗口
			checkcoloption: [{ checkcol: '订单号' }, { checkcol: '快递单号' }],
			l_mode: '',
			fun: '',
			checkcol: '订单号',
			btndisabled:true,
			l_id:'',
			firstpkval:''//有效单号中的第一个
			
		};
	},
	mounted() {},
	methods: {
		init(param) {
			this.l_mode = param.l_mode;
			this.showpastorderwin = true;
			this.checkedbatch = '';
			this.orderids = '';
			this.allcount = 0;
			this.yxcount = -1;
			this.checkedbatch = '';
			this.filename = ''; //无效的单号文件
			this.fun = param.fun;
			this.l_id=param.l_id;
			this.firstpkval='';
		},
		nextstep() {
			if (this.orderids == '') {
				this.$tool.message('请输入单号', 0);
				return false;
			}
			if (this.checkedbatch == '') {
				this.$tool.message('单号未检测，请重新输入', 0);
				return false;
			}
			this.showpastorderwin = false;
			this.$emit('pastorderhandler', {
				checkedbatch: this.checkedbatch,
				fun: this.fun,
				l_id:this.l_id,
				yxcount:this.yxcount,
				firstpkval:this.firstpkval
			});
		},
		//切换检测条件
		changecheckcol(val) {
			this.checkcol = val;
			this.CheckPasteOrder();
		},
		//检测单号
		CheckPasteOrder(event) {
			this.checkedbatch = '';
			var checkcol = '';
			this.btndisabled=true;
			var isgo=true;
			if(event!=undefined){
				if(event.code!='KeyV'&&event.keyCode != 13){
					isgo=false;
				}
			}
			if(isgo){
				if (this.orderids != '') {
					var paraminfo = {
						batch: this.checkedbatch,
						userid: localStorage.getItem('userid'),
						l_mode: this.l_mode,
						checkcol: this.checkcol,
						orderids: this.orderids
					};
					var that = this;
					this.$tool.loading('正在验证单号', 'pastorderwin');
					//console.log('检测',JSON.stringify(paraminfo));
					this.$apipost.post.CheckPasteOrder({ paraminfo: paraminfo }).then(res => {
						this.$tool.loadingclose();
						if (res != '') {
							if (res.state == '1') {
								that.checkedbatch = res.batch;
								that.firstpkval=res.pkval;//粘贴的第一个有效单号
								that.filename = unescape(res.filename);
								that.yxcount = res.yxcount;
								if(parseInt(that.yxcount)>0)
									that.btndisabled=false;
								that.allcount = res.count;
							} else {
								this.$tool.message(res.message, 0);
							}
						} else {
							this.$tool.message('检测异常', 0);
						}
					});
				}
			}			
		}
	}
};
</script>

<style></style>
